module.exports = __webpack_public_path__ + "img/gala-journey.5d3ff471.svg";